import api from './api';

export interface UsuarioSubstitutoModel {
  regrasGeral: UsuarioSubstitutoTableModel;
  regrasRejeitadas: UsuarioSubstitutoTableModel;
}

export interface UsuarioSubstitutoTableModel {
  id: string;
  usuarioOriginal: string;
  usuarioSubstituto: string;
  substituirDepartamento: boolean;
  razaoSocialFornecedor: string;
  temporaria: boolean;
  dataInicial: string;
  dataFinal: string;
  areaNome: string;
  contratoDescricao: string;
  diretoriaNome: string;
  justificativaSubstituicao: string;
  aprovador: string;
  dataAprovacao: string;
  dataProcessamentoInicial: string;
  dataProcessamentoFinal: string;
  motivoRejeicao: string;
  usuarioSolicitante: string;
  dataSolicitacao: string;
  statusNome: string;
  statusCodigo: number;
}

export interface VerificarPerfilLogado {
  id: string;
  perfilTemPermissaoCadastrarUsuarioSubstituto: boolean;
}

export interface CadastroUsuarioSubstituto {
  usuarioOriginal: string;
  usuarioSubstituto: string;
  areas: string[];
  contratos: string[];
  temporaria: boolean;
  dataInicial: string;
  dataFinal: string;
  justificativaSubstituicao: string;
}

export const getAllRegraSubstituto = () => api.get<UsuarioSubstitutoModel>('regraSubstituto');

export const getVerificarPerilLogado = () => api.get<VerificarPerfilLogado>('regraSubstituto/verificarPerfilLogado');

export const updateDadosUsuarioSubstitutoContratos = (cadastroUsuarioSubstituto: CadastroUsuarioSubstituto) => {
  return api.post(`regraSubstituto/cadastroContratos`, cadastroUsuarioSubstituto);
};

export const aprovar = (id: string) => {
  return api.post(`regraSubstituto/aprovar`, { id });
};

export const excluir = (id: string) => {
  return api.post(`regraSubstituto/excluir`, { id });
};

export const rejeitar = (id: string, motivo: string) => {
  return api.post<any>(`regraSubstituto/rejeitar`, { id, motivo });
};

export const getProcessadosList = (id: string) => {
  return api.get(`regraSubstituto/processados/${id}`);
};
